<template>
  <Head v-if="status == 1" title="Activate Account" />
  <Head v-else title="Password Reset" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-orange-200" style="background-color: #e9ecef;">
    <div class="w-1/2 max-w-md">
      <div class="text-center">
        <img class="object-center" src="/../images/Color_logo_no_background.svg" width="150" style="display: block; margin: 0 auto;" />
      </div>
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="store">
        <div class="px-5 py-5">
          <h1 v-if="status == 1" class="text-center text-3xl font-bold">Activate Account</h1>
          <h1 v-else class="text-center text-3xl font-bold">Password reset</h1>
          <div class="mt-1 mx-auto w-24 border-b-2" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
          <text-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Password" type="password" />
          <text-input v-model="form.password_confirmation" :error="form.errors.password_confirmation" class="mt-6" label="Password Confirmation" type="password" />
        </div>
        <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
          <loading-button v-if="status == 1" :loading="form.processing" class="btn-orange ml-auto" type="submit">Activate</loading-button>
          <loading-button v-else :loading="form.processing" class="btn-orange ml-auto" type="submit">Reset Password</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  remember: 'form',
  props: {
    email: String,
    token: String,
    status: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: this.email,
        token: this.token,
        password: null,
        password_confirmation: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/password/reset')
    },
  },
}
</script>
